import React from 'react';
import SocialIcon from './SocialIcon';

const FooterBottom: React.FC = () => {
    const socialIcons = [
        { icon: '📘', href: '#' },
        { icon: '📧', href: '#' },
        { icon: '📱', href: '#' }
    ];
    const currentYear = new Date().getFullYear();

    return (
        <div className="border-t border-gray-700 mt-8 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                <div className="text-sm text-gray-400">
                    <p>&copy; {currentYear} Eldaï. Tous droits réservés.</p>
                </div>

                <div className="flex items-center space-x-4 d-none">
                    <span className="text-sm text-gray-400">Suivez-nous:</span>
                    <div className="flex space-x-3">
                        {socialIcons.map((social, index) => (
                            <SocialIcon key={index} icon={social.icon} href={social.href} />
                        ))}
                    </div>
                </div>

                <div className="text-sm text-gray-400">
                    <p>Fait par <a href="https://www.linkedin.com/in/isaac-benjamin-dahan-ba44b1190/" className="link">Ben Dahan</a></p>
                </div>
            </div>
        </div>
    );
};

export default FooterBottom;
